import React, { useState, useEffect } from 'react';
import BuildAccordion from './BuildAccordion';
import { IoClose } from "react-icons/io5";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { addbuildsheet, getbuildsheet, getbuildsheetdata, upateBuildSheetStatus } from "../../Api/buildsheetApi"
import { getCurrentUser } from "../../Api/auth";
import DriverWood from "./DriverWood";
import Hybrid from "./Hybrid";
import IronWedge from "./IronWedge";
import Wedge from "./Wedge";
import Putter from "./Putter";
import { StagingStGet } from '../../Api/StagingSt';
import { useHistory } from 'react-router-dom';
import { getAllStagingStations, getNonEmptyStations } from '../../Api/StagingStationsApi'

function BuildSheetLeft({ buildsheetdataa, allmodels, StagingStations, nonEmptyStagingStation, buildsheets, remortFittingFormData }) {

    const history = useHistory();

    const goBack = () => {
        history.goBack();
    };

    const params = useParams();
    const id = params.id;

    const [scrolled, setScrolled] = useState(false);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);
    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const [show3, setShow3] = useState(false);

    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);

    const [show4, setShow4] = useState(false);

    const handleClose4 = () => setShow4(false);
    const handleShow4 = () => setShow4(true);

    const [show5, setShow5] = useState(false);

    const handleClose5 = () => setShow5(false);
    const handleShow5 = () => setShow5(true);

    const [show6, setShow6] = useState(false);

    const handleClose6 = () => setShow6(false);
    const handleShow6 = () => setShow6(true);

    const [buildsheetdata, setBuildSheetData] = useState([]);
    const [buildsheetnumber, setBuildSheetNumber] = useState(0);
    const [buildsheetid, setBuildSheetId] = useState(0);

    const [buildApiCall, setBuildApiCall] = useState(0);
    const [apicallupate, setApicallUpate] = useState(false);

    const [userdata, setUserdata] = useState('');
    const [closePopup, setClosePopup] = useState('');
    const [buildstatus, setBuildstatus] = useState(false);

    const [show02, setShow02] = useState(false);

    const handleClose02 = () => setShow02(false);
    const handleShow02 = () => setShow02(true);
    // const [StagingStations, setStagingStations] = useState([]);
    // const [nonEmptyStagingStation, setNonEmptyStagingStation] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('Unassigned');
    const [selectedOptionsId, setselectedOptionsId] = useState('0');

    const [errors, setErrors] = useState([]);

    const [selectedButtons, setSelectedButtons] = useState([]);
    const [verify1, setVerify1] = useState(false);

    const [buttonNames, setButtonNames] = useState([
        "Driver", "3 Wood", "5 Wood", "7 Wood", "9 Wood", "2 Hybrid",
        "3 Hybrid", "4 Hybrid", "5 Hybrid", "6 Hybrid", "7 Hybrid", "8 Hybrid",
        "1 Iron", "2 Iron", "3 Iron", "4 Iron", "5 Iron", "6 Iron",
        "7 Iron", "8 Iron", "9 Iron", "GW", "SW", "LW", 'Putter'
    ]);
    const [options, setOptions] = useState([{ text: 'Unassigned', color: 'white', number: 0 }]);

    const [title, setTitle] = useState('');

    const closeDropdown = () => {
        setIsOpen(false);
    };

    const getDataById = async () => {
        // return getbuildsheet({ id: id })
        // .then((res) => {
        //         if (res?.code === 200) {
        //             const Data = res.data.data;

        //             setBuildSheetNumber(Data.buildnumber);
        //             if (Data._id != undefined) {

        //                 setBuildSheetId(Data._id);
        //                 setselectedOptionsId(Data.station_Id);
        //                 setSelectedOption(Data.station_name);
        //                 setBuildstatus(Data.build_status);
        //             }
        //         } else {
        //             alert(res.data?.message);
        //         }
        //     }).catch((err) => {
        //         alert(err);
        //     });

        if (buildsheets) {
            const Data = buildsheets;
            setBuildSheetNumber(Data.buildnumber);
            if (Data._id != undefined) {
                setBuildSheetId(Data._id);
                setselectedOptionsId(Data.station_Id);
                setSelectedOption(Data.station_name);
                setBuildstatus(Data.build_status);
            }
        }
    };

    useEffect(() => {
        getDataById();
    }, [buildsheets]);

    const buildStGets = () => {
        let newOptions = '';

        const assignedStationIds = nonEmptyStagingStation.map(station => station.station_Id);
        if (nonEmptyStagingStation.length > 0) {
            const nonAssignedStations = StagingStations.filter(station => !assignedStationIds.includes(station.Staging_Stations_id));
            newOptions = nonAssignedStations.map(station => ({
                text: station.Staging_Stations_name,
                number: Number(station.Staging_Stations_id),
                color: "white"
            }));
        } else {
            newOptions = StagingStations.map(station => ({
                text: station.Staging_Stations_name,
                number: Number(station.Staging_Stations_id),
                color: "white"
            }));
        }

        setOptions(prevOptions => [
            { text: 'Unassigned', color: 'white', number: 0 },
            ...newOptions
        ]);
    }

    const getbuildSheetDataById = async () => {
        return getbuildsheetdata({ id: id })
            .then((res) => {
                if (res?.code === 200) {
                    const Data = res.data.data;
                    setBuildSheetData(Data);
                } else {
                    alert(res.data?.message);
                }
            }).catch((err) => {
                alert(err);
            });
        // if(buildsheetdataa){
        //     setBuildSheetData(buildsheetdataa);
        // }
    };

    const openmodelpop = (index, name) => {

        var showname = "";
        setTitle(name)
        let parts = name.split(" ");
        if (parts.length > 1) {
            showname = parts[1];
        } else {
            showname = parts[0];
        }

        ////console.log("showname", showname);
        if (showname === "Driver" || showname === "Wood") {
            handleShow2();
            handleClose();
        }

        if (showname === "Hybrid") {
            handleShow3();
            handleClose();
        }

        if (showname === "Iron" || showname === "Wedge") {
            handleShow4();
            handleClose();
        }

        if (showname === "Putter") {
            handleShow6();
            handleClose();
        }

        if (showname === "GW" || showname === "SW" || showname === "LW") {
            handleShow5();
            handleClose();
        }
    }

    useEffect(() => {
        if (closePopup === "driver&Wood") {
            handleClose2();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Hybrid") {
            handleClose3();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Iron&Wedge") {
            handleClose4();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Wedge") {
            handleClose5();
            getDataById();
            getbuildSheetDataById();
        }

        if (closePopup === "Putter") {
            handleClose6();
            getDataById();
            getbuildSheetDataById();
        }
        setClosePopup('');

    }, [closePopup])

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();

        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }

        // getAllStagingStations();
        getDataById();
        getbuildSheetDataById();
    }, [id]);

    useEffect(() => {
        buildStGets();
    }, [StagingStations, nonEmptyStagingStation]);


    useEffect(() => {
        if (buildApiCall !== 0) {
            getbuildSheetDataById();
        }
    }, [buildApiCall])

    useEffect(() => {
        if (buildsheetdataa) {
            setBuildSheetData(buildsheetdataa);
        }
    }, [buildsheetdataa])


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Driver + Wood Modal End Here  */}
            <Modal size="lg" centered show={show} onHide={handleClose} className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">Add Club</h3>
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className='modal-select-btn'>
                        <div className='select-btn-list'>
                            {buttonNames.map((name, index) => (
                                <div className='select-btn-item' key={index}>
                                    <button
                                        type="button"
                                        className={`btn btn-primary btn-select ${selectedButtons.includes(index) ? 'selected' : ''}`}
                                        // onClick={() => handleButtonClick(index, name)}
                                        onClick={() => openmodelpop(index, name)}
                                    >
                                        {name}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={show02}
                onHide={handleClose02}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <div className="logo-modal">
                            <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                        </div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose02} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className='modal-image'>
                        <img src={require('../../assets/images/forewardFormSubmitClubOrder.png')} alt="logo" />
                    </div>
                    <h3 className="text-center mb-4">
                        Your Project Update Successfully.
                    </h3>
                </Modal.Body>
            </Modal>

            {/* <div className="build_number_box">
                <div className="build_number_box_inner">
                    <div className="build_title">
                        Build Number
                    </div>
                    <div className="build_number">
                        {buildsheetnumber || 0}
                    </div>
                </div>
            </div> */}
            <BuildAccordion buildsheets={buildsheetdata} ondeleteChange={(deleteid) => setBuildApiCall(deleteid)} selectedOptions={selectedOption} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
            <>
                {buildsheetnumber === 0 ? (
                    ""
                ) : (
                    // <div className="btn-box-section btn-inline-box">
                    //     {/* <button className="btn btn-primary btn-remove">Remove Build</button> */}
                    //     {/* <button className="btn btn-primary btn-create">Save Build</button> */}
                    // </div>
                    <div></div>
                )}
            </>

            {/* Driver + Wood Modal Start Here */}
            <Modal size="lg" show={show2} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">{title}</h3>
                            <button type="button" className="btn-close" onClick={handleClose2} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className="modal-long-form">
                        <DriverWood project_id={id} title={title} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} selectoptiondata={selectedOption} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                    </div>
                </Modal.Body>
            </Modal>

            {/* Hybrid Modal Start Here */}
            <Modal size="lg" show={show3} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">{title}</h3>
                            <button type="button" className="btn-close" onClick={handleClose3} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className="modal-long-form">
                        <Hybrid project_id={id} title={title} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} selectoptiondata={selectedOption} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                    </div>
                </Modal.Body>
            </Modal>
            {/* Hybrid Modal End Here  */}

            {/* Iron + Wedge Start Here */}
            <Modal size="lg" show={show4} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">{title}</h3>
                            <button type="button" className="btn-close" onClick={handleClose4} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className="modal-long-form">
                        <IronWedge project_id={id} title={title} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} selectoptiondata={selectedOption} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                    </div>
                </Modal.Body>
            </Modal>
            {/* Iron + Wedge End Here  */}

            {/* Wedge Start Here */}
            <Modal size="lg" show={show5} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">{title}</h3>
                            <button type="button" className="btn-close" onClick={handleClose5} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className="modal-long-form">
                        <Wedge project_id={id} title={title} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} selectoptiondata={selectedOption} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                    </div>
                </Modal.Body>
            </Modal>
            {/* Wedge End Here  */}

            {/* Putter Start Here */}
            <Modal size="lg" show={show6} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">{title}</h3>
                            <button type="button" className="btn-close" onClick={handleClose6} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className="modal-long-form">
                        <Putter project_id={id} title={title} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} selectoptiondata={selectedOption} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                    </div>
                </Modal.Body>
            </Modal>
            {/* Putter End Here  */}
            <style>
                {
                    `
                                .unique .modal-dialog{
                                    max-width: 100% !important;
                                     width: 100% !important;
                                }
                                `
                }
            </style>
        </>
    );
}

export default BuildSheetLeft;